import { NgModule } from '@angular/core';
import {OneSignalPushNotificationsService} from "./one-signal-push-notifications.service";
import {PushNotificationsService} from "./domain/push-notifications.service";



@NgModule({
  providers: [
    {provide: PushNotificationsService, useClass: OneSignalPushNotificationsService},
  ],
})
export class PushNotificationsModule { }
